import { AuthChangeEvent, Session } from "@supabase/supabase-js";
import { MakeInjectable } from "../DependencyInjection/DependencyInjection";
import { SimpleObservable } from "../Observable/Observable";
import { SupabaseService } from "../Supabase/SupabaseService";

export class AuthService{
    private _authStatus: SimpleObservable<AuthChangeEvent|null> = new SimpleObservable<AuthChangeEvent|null>(null);
    private _session: SimpleObservable<Session|null> = new SimpleObservable<Session|null>(null);

    public get authStatus(){
        return this._authStatus;
    }

    public get session(){
        return this._session;
    }

    constructor(private supabase: SupabaseService){
        this.supabase.instance.auth.onAuthStateChange((event, session) => {
            this._authStatus.setValue(event);
            this._session.setValue(session);
        });
    }

    public async signIn(email: string, password: string){
        return this.supabase.instance.auth.signInWithPassword({
            email,
            password
        });
    }

    public async signUp(email: string, password: string){
        return this.supabase.instance.auth.signUp({
            email,
            password
        });
    }

    public async signOut(){
        return this.supabase.instance.auth.signOut();
    }
}

MakeInjectable(AuthService, [SupabaseService]);